import { render, staticRenderFns } from "./ProfileSettings.htm?vue&type=template&id=4b325b25&scoped=true&"
import script from "./ProfileSettings.ts?vue&type=script&lang=js&"
export * from "./ProfileSettings.ts?vue&type=script&lang=js&"
import style0 from "./ProfileSettings.scss?vue&type=style&index=0&id=4b325b25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b325b25",
  null
  
)

export default component.exports